import {
  CONNECTED_PROFILE_LIST,
  CREATE_LEAD,
  IMPORT_LEAD_DATA,
  LEAD_LIST,
  UPDATE_LEAD,
  UPDATE_LEAD_STATUS,
  VIEW_LEAD,
} from "./apiRoutes";
import { authData, multipartDataWithToken } from "./Service";

export const createLeadApi = async (data) => {
  const response = await authData.post(CREATE_LEAD, data);
  return response?.data;
};
export const listOfLeadApi = async (data) => {
  const response = await authData.post(LEAD_LIST, data);
  return response?.data;
};
export const updateLeadApi = async (data) => {
  const response = await authData.put(UPDATE_LEAD, data);
  return response?.data;
};
export const viewLead = async (id) => {
  const response = await authData.get(`${VIEW_LEAD}${id}`);
  return response?.data;
};
export const updateLeadStatusApi = async (data) => {
  const response = await authData.put(UPDATE_LEAD_STATUS, data);
  return response?.data;
};
export const listOfConnectedProfileApi = async (data) => {
  const response = await authData.post(CONNECTED_PROFILE_LIST, data);
  return response?.data;
};
export const importLeadDataApi = async (formData) => {
  const response = await multipartDataWithToken.post(
    IMPORT_LEAD_DATA,
    formData
  );
  return response?.data;
};
